/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
export const ROLE_NAMES = {
  ADMN: 'administration',
  ENG: 'engineering',
  GOV: 'governance',
  MRKT: 'marketing',
  OTH: 'other'
};

export const OBJECTIVE_NAMES = {
  AUDIENCES: 'audiences',
  COMPLIANCE: 'compliance',
  DASHBOARD: 'dashboard',
  INGESTION: 'ingestion',
  INSIGHTS: 'insights',
  LICENSE: 'license',
  OTHER: 'other',
  POLICIES: 'policies',
  PROFILES: 'profiles',
  STRATEGIES: 'strategies',
  STRUCTURE: 'structure',
  TARGETING: 'targeting',
  USERS: 'users'
};
